// 将所有的存储内容 末尾增加图书id，或者示例'example'，用以区分不同图书的存储数据
let markList = 'markList';
let mindMap = 'mindMap';
let readPercentData = 'readPercentData';
let actionData = 'actionData';
let historyPosition = 'historyPosition';
let storageStr = ((str) => {
  let book_id = getHashSearchParam("book_id");
  let book_name = book_id || 'example';
  return str + '_' + book_name
})

//标记内容 包含高亮、笔记
export function getMarkList() {
  return localStorage.getItem(storageStr(markList))
}
export function setMarkList(markListStr) {
  localStorage.setItem(storageStr(markList), markListStr)
}
export function removeMarkList() {
  return localStorage.removeItem(storageStr(markList))
}

// 全部脑图内容
export function getMindMap() {
  return localStorage.getItem(storageStr(mindMap))
}
export function setMindMap(mindMapList) {
  localStorage.setItem(storageStr(mindMap), mindMapList)
}
export function removeMindMap() {
  return localStorage.removeItem(storageStr(mindMap))
}

// 全部读书进度数据
export function getReadPercent() {
  return localStorage.getItem(storageStr(readPercentData))
}
export function setReadPercent(readPercentDataList) {
  localStorage.setItem(storageStr(readPercentData), readPercentDataList)
}
export function removeReadPercent() {
  return localStorage.removeItem(storageStr(readPercentData))
}

// 答题交互记录
export function getActionData() {
  return localStorage.getItem(storageStr(actionData))
}
export function setActionData(actionDataList) {
  localStorage.setItem(storageStr(actionData), actionDataList)
}
export function removeActionData() {
  return localStorage.removeItem(storageStr(actionData))
}

// 记录电子书的历史位置
export function getHistoryPosition() {
  return localStorage.getItem(storageStr(historyPosition))
}
export function setHistoryPosition(historyPositionList) {
  localStorage.setItem(storageStr(historyPosition), historyPositionList)
}
export function removeHistoryPosition() {
  return localStorage.removeItem(storageStr(historyPosition))
}


// 获取url参数
function getHashSearchParam(key) {
  const url = location.href
  // 获取 hash 值，不包含 '#' 号
  const hash = url.substring(url.indexOf("#") + 1)
  // 查找 '?' 号所在的索引
  const searchIndex = hash.indexOf("?")
  // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
  const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : ""
  // 把搜索参数字符串提过URLSearchParams转成对象形式
  const usp = new URLSearchParams(search)
  // 通过URLSearchParams自带的get方法，查询键所对应的值
  return usp.get(key)
}